/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResponseForAgentInsightPanel extends models.BaseForAgentResponse {
    constructor() {
        super();
        this.setDiscriminator("InsightPanel");
    }

    getFixupPrototypeFunction() { return ResponseForAgentInsightPanel.fixupPrototype; }

    static newInstance(model: Partial<ResponseForAgentInsightPanel>): ResponseForAgentInsightPanel {
        let obj = Object.assign(new ResponseForAgentInsightPanel(), model);
        ResponseForAgentInsightPanel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResponseForAgentInsightPanel>): ResponseForAgentInsightPanel {
        if (!model) return null;
        return ResponseForAgentInsightPanel.newInstance(<ResponseForAgentInsightPanel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResponseForAgentInsightPanel) {
        if (!obj) return;

        models.ResponseForAgentInsightPanel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResponseForAgentInsightPanel): boolean {
        if (models.BaseForAgentResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResponseForAgentInsightPanel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Self-contained OSCAR-styled HTML snippet (1-2 widgets), rendered inline in chat
     */
    value: string;

}
